import { useEffect, useRef, useState } from 'react';

import EcoImg from 'eco-design/base/eco-img';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';

import { useLang } from '@/app/utils/useLang';

import AnimatedSection, { AnimatedGrid } from '../AnimatedSection';
import Arrow from './arrow';
import styles from './index.module.scss';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import { useInViewport } from 'ahooks';
import gtm from '@/utils/gtm';
import ProductCard from '@elem/compPage/delta-3-max-plus-portable-power-station/pages/product/components/ProductCard';

interface BannerProps {
    pageType: 'ultra' | 'max';
}

const OnePicture: React.FC<BannerProps> = ({ pageType }: BannerProps = { pageType: 'max' }) => {
    const { t } = useLang('OnePicture');

    const PRODUCT_IMAGE_URL_HAVE = 'https://websiteoss.ecoflow.com/figma-uploads/1758030024587-sse8rb-compressed-Frame%201612708211.jpg';

    const item0ImgMap = {
        max: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758191920624-8r3kq9-compressed-Frame%202094654414.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758083406611-epn0v4-compressed-Frame%202094654406.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758083406611-epn0v4-compressed-Frame%202094654406.jpg',
        },
        ultra: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538116895-scsw3v-compressed-Frame%201612708216.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758538116895-scsw3v-compressed-Frame%201612708216.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758781119418-v7dk4r-compressed-Frame%202094654415.jpg',
        },
    };

    const item1ImgMap = {
        max: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758026303340-mhvyxx-compressed-Frame%201612708200.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758026303340-mhvyxx-compressed-Frame%201612708200.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758263266369-52s2vk-compressed-Frame%201000008658.jpg',
        },
        ultra: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538189648-jqxxc5-compressed-Frame%201612708203.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758538189648-jqxxc5-compressed-Frame%201612708203.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1759049111273-dpvk6o-compressed-Frame%202094654430.jpg',
        },
    };

    const item2ImgMap = {
        max: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758026318567-phsb15-compressed-Frame%201612708203.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758026318567-phsb15-compressed-Frame%201612708203.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758787259362-y4zn3s-compressed-Frame%201000008654.jpg',
        },
        ultra: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538215600-2v3drb-compressed-Frame%201612708204.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758538215600-2v3drb-compressed-Frame%201612708204.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758538322893-g5po4z-compressed-Frame%202094654414.jpg',
        },
    };

    const item3ImgMap = {
        max: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758780625943-f0329v-compressed-Frame%202094654425.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758780625943-f0329v-compressed-Frame%202094654425.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758780604020-m952uj-compressed-Frame%202094654405.jpg',
        },
        ultra: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758780625943-f0329v-compressed-Frame%202094654425.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758780625943-f0329v-compressed-Frame%202094654425.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758780604020-m952uj-compressed-Frame%202094654405.jpg',
        },
    };

    const item4ImgMap = {
        max: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758026344572-2qa36f-compressed-Frame%201612708205.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758026344572-2qa36f-compressed-Frame%201612708205.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758787292553-ry6x9i-compressed-Frame%202094654407.jpg',
        },
        ultra: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758859340668-bto4s2-compressed-Frame%202094654394.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758859340668-bto4s2-compressed-Frame%202094654394.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1759048407918-kehd2w-compressed-Frame%202094654412.jpg',
        },
    };

    const itme5ImgMap = {
        max: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758271601620-rrep59-compressed-Frame%202094654417.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758271601620-rrep59-compressed-Frame%202094654417.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758787388050-ut1wtk-compressed-Frame%202094654419.jpg',
        },
        ultra: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538254369-vzj9ek-compressed-Frame%201612708205.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758538254369-vzj9ek-compressed-Frame%201612708205.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758720258388-mpxanc-compressed-Frame%202094654411.jpg',
        },
    };

    const itme6ImgMap = {
        max: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758026364567-1v52s9-compressed-Frame%201612708207.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758026364567-1v52s9-compressed-Frame%201612708207.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758263360937-acb8fv-compressed-Frame%201612707627.jpg',
        },
        ultra: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758538267086-k9o9oc-compressed-Frame%202094654395.jpg',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758538267086-k9o9oc-compressed-Frame%202094654395.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1758538389698-dy6vfq-compressed-Frame%202094654410.jpg',
        },
    };

    const itemsList = [
        {
            title: t('title1'),
            desc: t('desc1'),
            pc: item0ImgMap[pageType as keyof typeof item0ImgMap].pc,
            pad: item0ImgMap[pageType as keyof typeof item0ImgMap].pad,
            h5: item0ImgMap[pageType as keyof typeof item0ImgMap].h5,
            href: pageType === 'max' ? '#Output' : '#PriorityOutputs',
        },
        {
            title: t.rich('title2', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc2'),
            pc: item1ImgMap[pageType as keyof typeof item1ImgMap].pc,
            pad: item1ImgMap[pageType as keyof typeof item1ImgMap].pad,
            h5: item1ImgMap[pageType as keyof typeof item1ImgMap].h5,
            href: pageType === 'max' ? '#ChargeUp' : '#TabSection',
        },
        {
            // 文字 H5端更改
            title: t('title3'),
            desc: t('desc3'),
            pc: item2ImgMap[pageType as keyof typeof item2ImgMap].pc,
            pad: item2ImgMap[pageType as keyof typeof item2ImgMap].pad,
            h5: item2ImgMap[pageType as keyof typeof item2ImgMap].h5,
            href: pageType === 'max' ? '#PriorityOutputs' : '#Output',
        },
        {
            title: t.rich('title4', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc4'),
            pc: item3ImgMap[pageType as keyof typeof item3ImgMap].pc,
            pad: item3ImgMap[pageType as keyof typeof item3ImgMap].pad,
            h5: item3ImgMap[pageType as keyof typeof item3ImgMap].h5,
            href: pageType === 'max' ? '#CoverSection3' : '#videoSection8',
        },
        {
            title: t('title5'),
            desc: t('desc5'),
            pc: item4ImgMap[pageType as keyof typeof item4ImgMap].pc,
            pad: item4ImgMap[pageType as keyof typeof item4ImgMap].pad,
            h5: item4ImgMap[pageType as keyof typeof item4ImgMap].h5,
            href: pageType === 'max' ? '#Built' : '#TwoEasy',
        },
        {
            title: t('title6'),
            desc: t('desc6'),
            pc: itme5ImgMap[pageType as keyof typeof itme5ImgMap].pc,
            pad: itme5ImgMap[pageType as keyof typeof itme5ImgMap].pad,
            h5: itme5ImgMap[pageType as keyof typeof itme5ImgMap].h5,
            href: pageType === 'max' ? '' : '#Built',
        },
        {
            title: t.rich('title7', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc7'),
            pc: itme6ImgMap[pageType as keyof typeof itme6ImgMap].pc,
            pad: itme6ImgMap[pageType as keyof typeof itme6ImgMap].pad,
            h5: itme6ImgMap[pageType as keyof typeof itme6ImgMap].h5,
            href: pageType === 'max' ? '#TabSection' : '#ChargeUp',
        },
    ];
    const [items, setItems] = useState<typeof itemsList>(itemsList);

    const { isH5 } = useDeviceDetect();
    useEffect(() => {
        if (isH5 && pageType === 'ultra') {
            const newItems = itemsList.map((item) => ({
                ...item,
                title: item.title,
                desc: item.desc,
            }));
            const tempTitle = newItems[1].title;
            const tempDesc = newItems[1].desc;
            newItems[1].title = newItems[2].title;
            newItems[1].desc = newItems[2].desc;
            newItems[2].title = tempTitle;
            newItems[2].desc = tempDesc;
            setItems(newItems);
        } else {
            setItems(itemsList);
        }
    }, [pageType, isH5]);

    const handleScrollInToView = (href: string, className: string, dataBtnId: string) => {
        const element = document.getElementById(href.replace('#', ''));
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }

        gtm.push({
            __btn_id1: `${styles.OnePicture} .${className}`,
            __btn_id2: dataBtnId,
            __btn_type: 'common',
            __bth_only_ef: true,
        });
    };

    const [item1Img, setItem1Img] = useState('');
    const [item6Img, setItem6Img] = useState('');
    const OnePictureRef = useRef<HTMLDivElement>(null);

    const [inViewport] = useInViewport(OnePictureRef);

    useEffect(() => {
        if (inViewport) {
            setItem1Img(isH5 ? items[1].h5 : items[1].pc);
            setItem6Img(isH5 ? items[6].h5 : items[6].pc);
        }
    }, [inViewport]);

    return (
        <div ref={OnePictureRef} className={`${styles.OnePicture} d3m-layout GtmModuleData-section`} id="OnePicture" data-section-id="d3m-one-picture">
            <AnimatedSection
                variant="rotateIn"
                options={{ delay: 100 }}
                className="item item-1 GtmModuleData-btn-common d3m-one-picture-0"
                dataBtnId="one-picture-item-0"
                onClick={() => handleScrollInToView(items[0].href || '', 'd3m-one-picture-0', 'one-picture-item-0')}
            >
                <EcoImg key={2} pc={PRODUCT_IMAGE_URL_HAVE} pad={items[0].pad} h5={items[0].h5} isOpenLazy={true} />

                <div className="text-wrapper">
                    <div className="title">{items[0].title}</div>
                    <div className="desc">{items[0].desc}</div>
                </div>
                <div className="arrow">
                    <Arrow />
                </div>
            </AnimatedSection>

            <div className="item-2">
                <AnimatedSection
                    variant="rotateIn"
                    dataBtnId="one-picture-item-1"
                    options={{ delay: 200 }}
                    className={'item item-2-1 GtmModuleData-btn-common d3m-one-picture-1 ' + pageType}
                    onClick={() => handleScrollInToView(items[1].href || '', 'd3m-one-picture-1', 'one-picture-item-1')}
                >
                    {/* <EcoImg pc={items[1].pc} pad={items[1].pad} h5={items[1].h5} isOpenLazy={false} /> */}
                    <picture className="picture">
                        <source srcSet={item1Img} type="image/webp" />
                        <img src={item1Img} alt={t('A_title')} width="100%" height="100%" />
                    </picture>
                    <div className="text-wrapper">
                        <div className="title">{items[1].title}</div>
                        <div className="desc">{items[1].desc}</div>
                    </div>
                    <div className="arrow">
                        <Arrow />
                    </div>
                </AnimatedSection>

                <AnimatedSection variant="rotateIn" options={{ delay: 200 }} className="item-2-2">
                    <div
                        className={'item item-2-2-1 GtmModuleData-btn-common d3m-one-picture-2 ' + ' ' + pageType}
                        data-btn-id="one-picture-item-2-2-1"
                        onClick={() => handleScrollInToView(items[2].href || '', 'd3m-one-picture-2', 'one-picture-item-2-2-1')}
                    >
                        <EcoImg pc={items[2].pc} pad={items[2].pad} h5={items[2].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[2].title}</div>
                            <div className="desc">{items[2].desc}</div>
                        </div>
                        <div className="arrow">
                            <Arrow />
                        </div>
                    </div>
                    <div
                        className="item item-2-2-2 GtmModuleData-btn-common d3m-one-picture-3"
                        data-btn-id="one-picture-item-2-2-2"
                        onClick={() => handleScrollInToView(items[3].href || '', 'd3m-one-picture-3', 'one-picture-item-2-2-2')}
                    >
                        <EcoImg pc={items[3].pc} pad={items[3].pad} h5={items[3].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[3].title}</div>
                            <div className="desc">{items[3].desc}</div>
                        </div>
                        <div className="arrow">
                            <Arrow />
                        </div>
                    </div>
                </AnimatedSection>
            </div>

            <div className="item-3">
                <AnimatedGrid variant="rotateIn" options={{ delay: 100, stagger: 0.2 }} className="item-3-1">
                    <div
                        className="item item-3-1-1 GtmModuleData-btn-common d3m-one-picture-4"
                        data-btn-id="one-picture-item-3-1-1"
                        onClick={() => handleScrollInToView(items[4].href || '', 'd3m-one-picture-4', 'one-picture-item-3-1-1')}
                    >
                        <EcoImg pc={items[4].pc} pad={items[4].pad} h5={items[4].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[4].title}</div>
                            <div className="desc">{items[4].desc}</div>
                        </div>
                        <div className="arrow">
                            <Arrow />
                        </div>
                    </div>
                    <div
                        className="item item-3-1-2 GtmModuleData-btn-common d3m-one-picture-5"
                        data-btn-id="one-picture-item-3-1-2"
                        onClick={() => handleScrollInToView(items[5].href || '', 'd3m-one-picture-5', 'one-picture-item-3-1-2')}
                    >
                        <EcoImg pc={items[5].pc} pad={items[5].pad} h5={items[5].h5} isOpenLazy={true} />
                        <div className="text-wrapper">
                            <div className="title">{items[5].title}</div>
                            <div className="desc">{items[5].desc}</div>
                        </div>
                        {items[5].href && (
                            <div className="arrow">
                                <Arrow />
                            </div>
                        )}
                    </div>
                </AnimatedGrid>

                <AnimatedSection
                    variant="rotateIn"
                    options={{ delay: 100 }}
                    dataBtnId="one-picture-item-3-2"
                    className={'item item-3-2 GtmModuleData-btn-common d3m-one-picture-6 ' + (pageType === 'ultra' ? ' ultra' : ' max')}
                    onClick={() => handleScrollInToView(items[6].href || '', 'd3m-one-picture-6', 'one-picture-item-3-2')}
                >
                    {/* <EcoImg pc={items[6].pc} pad={items[6].pad} h5={items[6].h5} isOpenLazy={true} /> */}
                    <picture className="picture">
                        <source srcSet={item6Img} type="image/webp" />
                        <img src={item6Img} alt={t('A_title')} width="100%" height="100%" />
                    </picture>
                    <div className="text-wrapper">
                        <div className="title">{items[6].title}</div>
                        <div className="desc">{items[6].desc}</div>
                    </div>
                    <div className="arrow">
                        <Arrow />
                    </div>
                </AnimatedSection>
            </div>
            {pageType === 'max' && <ProductCard />}
        </div>
    );
};

export default OnePicture;
